module.exports = __webpack_public_path__ + "img/inge-v9-8.092d71de.png";